export default "__VITE_ASSET__77c4a95d__"